export default function getResource(label, vars = []) {
    const resources = {
        creditOrDebitCard: 'Credit or Debit Card',
        edit: 'Edit',
        remove: 'Remove'
    };

    return resources[label];
}
